import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { format } from "date-fns-tz";
import _ from "lodash";
import { useId } from "react";
import { FormattedMessage as T } from "react-intl";

const START_HOUR = 6;
const END_HOUR = 21;
const options = _.range(START_HOUR, END_HOUR).map(
  (i) => new Date(2000, 1, 1, i)
);

type HourPickerProps = {
  labelKey: string;
  value?: Date | null;
  onChange: (value: Date | null) => void;
};

export default function HourPicker({
  labelKey,
  value,
  onChange,
}: HourPickerProps) {
  // MUI names the select from labelId, not from an aria-labelledby prop.
  const labelId = useId();

  return (
    <FormControl size="small" fullWidth>
      <InputLabel id={labelId} sx={{ background: "white" }}>
        <T id={labelKey} />
      </InputLabel>
      <Select
        labelId={labelId}
        value={value?.getTime() ?? ""}
        onChange={(e) =>
          onChange(e.target.value ? new Date(e.target.value) : null)
        }
      >
        <MenuItem dense value=""></MenuItem>
        {options.map((o) => (
          <MenuItem dense value={o.getTime()} key={o.getTime()}>
            {format(o, "hh:mm aa")}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
